const Contact = () => {
    return ( 
        <ul>
            <li><a href="https://github.com/aneeqay" target="_blank"><img src="https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://github.com&size=256" /></a></li>
            <li><a href="https://www.linkedin.com/in/aneeqa-yusaf/" target="_blank"><img src="https://www.clipartmax.com/max/m2i8m2m2A0Z5K9Z5/" /></a></li>
        </ul>
     );
}
 
export default Contact;